// Sprint 13 — when the tab returns to foreground (PWA backgrounded then
// reopened, browser tab switched back), if the conversation the user was
// last viewing has a pending unread badge, clear it. The user "sees" the
// chat the moment they bring the tab to foreground; forcing them to click
// to dismiss is friction.
//
// Reads via `useAppStore.getState()` so the listener is registered once at
// mount and never re-binds.

import { useEffect } from 'react';
import { useAppStore } from '../stores/app.store';

export function useAutoMarkReadOnVisibility(): void {
  useEffect(() => {
    if (typeof document === 'undefined') return;
    function onVisibility() {
      if (document.visibilityState !== 'visible') return;
      const { selectedAgentId, agents, markRead } = useAppStore.getState();
      if (!selectedAgentId) return;
      const agent = agents[selectedAgentId];
      if (agent?.unread) markRead(selectedAgentId);
    }
    document.addEventListener('visibilitychange', onVisibility);
    return () => document.removeEventListener('visibilitychange', onVisibility);
  }, []);
}
